import script from "./PedidosTabla.vue?vue&type=script&setup=true&lang=js"
export * from "./PedidosTabla.vue?vue&type=script&setup=true&lang=js"

import "./PedidosTabla.vue?vue&type=style&index=0&id=5513730a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5513730a"]])

export default __exports__